import { CardType } from "../types"
import { FALLBACK_CATEGORIES_MAP } from "./data"

export const getImageUrl = (cardType: CardType) =>
  FALLBACK_CATEGORIES_MAP[cardType]
